// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!

/* tslint:disable */
export const VERSION = {
  version: "7.3.0",
  date: "2026-07-13T13:38:07.611Z",
  gitInfo: {
    dirty: false,
    raw: "bfbcc7ef0",
    hash: "bfbcc7ef0",
    distance: null,
    tag: null,
    semver: null,
    suffix: "bfbcc7ef0",
    semverString: null
  }
};
/* tslint:enable */
